import { render, staticRenderFns } from "./BaseRadioGroup.vue?vue&type=template&id=0044fb3c&scoped=true&"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js&"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseRadioGroup.scss?vue&type=style&index=0&id=0044fb3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0044fb3c",
  null
  
)

export default component.exports